import React, { Component } from "react";
//import * as _ from "lodash";
//import classNames from "classnames";

import QuizUi from "./widgets/QuizUi";

import { dayStrToParts } from "./QuizDay";
import { MONTH_CODES } from "./ui/Months";
import { numToNth } from "./util/util";

import { getLocaleLongMonth, getLocaleShortMonth } from "./util/localisation";

import "./QuizMonth.css";

const DISPLAY_FORMAT_SHORTMONTH = "SHORTMONTH";
const DISPLAY_FORMAT_LONGMONTH = "LONGMONTH";
const DISPLAY_FORMAT_HASHNUM = "HASHNUM";
const DISPLAY_FORMAT_NTH = "NTH";

export const getRandomDateFormatCode = (rand) => {
  if (rand < 0.25) {
    return DISPLAY_FORMAT_SHORTMONTH;
  }
  if (rand < 0.5) {
    return DISPLAY_FORMAT_LONGMONTH;
  }
  if (rand < 0.75) {
    return DISPLAY_FORMAT_HASHNUM;
  }
  return DISPLAY_FORMAT_NTH;
};

const formatDateStr = (month, format) => {
  if (format === DISPLAY_FORMAT_SHORTMONTH) {
    return getLocaleShortMonth(month).toUpperCase();
  }
  if (format === DISPLAY_FORMAT_LONGMONTH) {
    return getLocaleLongMonth(month);
  }
  if (format === DISPLAY_FORMAT_HASHNUM) {
    return "month #" + (month + 1);
  }
  if (format === DISPLAY_FORMAT_NTH) {
    return "the " + numToNth(month + 1) + " month";
  }
  return "???";
};

class QuizMonth extends Component {
  state = {
    answer: null,
  };

  componentWillMount() {}

  componentDidMount() {
    this.createQuestion();
  }

  componentDidUpdate(prevProps) {
    if (this.props.seed !== prevProps.seed) {
      this.createQuestion();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  createQuestion() {
    const { seed } = this.props;

    const { month } = dayStrToParts(seed.date);

    this.setState({
      answer: null,
      isCorrect: false,
      isWrong: false,
      wrongCount: 0,
      month,
      displayFormat: getRandomDateFormatCode(seed.random),
    });
  }

  onAnswer = (num) => {
    const correctValue = MONTH_CODES[this.state.month];
    const isCorrect = correctValue === num;
    this.setState(
      {
        answer: num,
        isCorrect,
        isWrong: !isCorrect,
      },
      this.waitAfterAnswer
    );
  };

  waitAfterAnswer = () => {
    this.timeout = setTimeout(this.afterWait, 1000);
  };

  afterWait = () => {
    if (this.state.isCorrect) {
      this.props.resetSeed();
    } else {
      this.setState({
        answer: null,
        isWrong: false,
        wrongCount: this.state.wrongCount + 1,
      });
    }
  };

  render() {
    const { month, displayFormat, answer, isCorrect, isWrong } = this.state;
    if (month === null) {
      return null;
    }

    const disabled = isCorrect || isWrong;

    return (
      <QuizUi
        className="QuizMonth"
        hide789
        answer={answer}
        disabled={disabled}
        isCorrect={isCorrect}
        isWrong={isWrong}
        onAnswer={this.onAnswer}>
        <strong className="-title">Practice Month Association</strong>
        <strong className="-question">
          Number for {formatDateStr(month, displayFormat)}?
        </strong>
      </QuizUi>
    );
  }
}

export default QuizMonth;
